import state from "../../state";

function chosenItemTemplate(
    { item, button, highlightedState, itemSelectable, placeholder },
    {
      id,
      value,
      label,
      customProperties,
      active,
      disabled,
      highlighted,
      placeholder: isPlaceholder,
    },
    removeItemButton,
  ) {
  const div = Object.assign(document.createElement('div'), {
    className: item,
    innerHTML: label,
  });

  Object.assign(div.dataset, {
    item: '',
    id,
    value,
    customProperties,
  });

  if (active) {
    div.setAttribute('aria-selected', 'true');
  }

  if (disabled) {
    div.setAttribute('aria-disabled', 'true');
  }

  if (isPlaceholder) {
    div.classList.add(placeholder);
  }

  div.classList.add(highlighted ? highlightedState : itemSelectable);

  div.classList.add(state.countryLabels.assigned(value));

  if (removeItemButton) {
    if (disabled) {
      div.classList.remove(itemSelectable);
    }
    div.dataset.deletable = '';

    const REMOVE_ITEM_TEXT = 'Remove item';
    const removeButton = Object.assign(document.createElement('button'), {
      type: 'button',
      className: button,
      innerHTML: REMOVE_ITEM_TEXT,
    });
    removeButton.setAttribute(
      'aria-label',
      `${REMOVE_ITEM_TEXT}: '${value}'`,
    );
    removeButton.dataset.button = '';
    div.appendChild(removeButton);
  }

  return div;
}

export {
  chosenItemTemplate
}
